const optionColumnsTradeFrequency = {
  chart: {
    toolbar: { show: false },
  },
  legend: { show: false },

  plotOptions: {
    bar: {
      dataLabels: {
        position: 'top',
      },
    },
  },

  fill: {
    colors: ['#4C515E'],
  },
  tooltip: {
    x: {
      format: 'DD/MM/yy',
    },
    y: {
      formatter: (value: number) => {
        return value?.toFixed(0);
      },
    },
    marker: {
      show: false,
    },
  },

  dataLabels: {
    enabled: true,
    offsetY: 10,
    style: {
      colors: ['#202227'],
    },
  },

  yaxis: {
    show: false,
  },
};

export default optionColumnsTradeFrequency;
